import { ValidationSet } from '../../../types/validation';

export const isNumberRules: ValidationSet = [
  {
    message: 'Must be a number',
    test: (value: string) => {
      return !(!value || /^[0-9]+$/.test(value));
    }
  }
];
